import { email, maxLength, minLength, required } from "ra-core";

export const validateEmail = [required(), email(), maxLength(100)];
export const validatePassword = [required(), minLength(5), maxLength(30)];
export const passwordsMatchValidation = (value: string, allValue: any) => {
  if (value !== allValue?.password) return "Passwords must match";
  return undefined;
};